import React, { useState,useSelector } from 'react';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsHeader from '@cybs-ui/components/lib/page-header';
import Card from '@visa/vds/card';
import CardContent from '@visa/vds/card-content';
import Typography from '@visa/vds/typography';
import Link from '@visa/vds/link';
import CardContentImage from '@visa/vds/card-content-image';
import CardContentSeparator from '@visa/vds/card-content-separator';
import CardContentFooter from '@visa/vds/card-content-footer';
import ButtonText from '@visa/vds/button-text';
import '../../css/home-section.css'
import { setDefaultHTTPCredsInCookies, setDefaultJWTCredsInCookies } from '../../../commons/cookie';
import { putDataInDevCenterDataStore } from '../../../app/store';
import { setWindowLocationHash, getProductMapJson, getMappingJsonFromID, useFontStyleFromEPC, getPartnerConfigVal } from '../../../libs/common-library.js';
import { isDefaultSite } from '../../../commons/ui-commons.js';
import { getPartnerFullName,getPartnerName, getSignUpURL } from '../../../lhs/reducers/configuration-reducer.js';
import { getCybsProductMapJson, getPartnerProductMapJson } from '../../../lhs/reducers/lhs-reducer.js';
import { getLHSBasedOnHostName, getLHSJsonData } from '../../../lhs/actions/navigation-actions';

function onClicker(name){
  /*const customData = require('../../../dist/json/lhs/'+getLHSBasedOnHostName());
  var lhsContents = getLHSJsonData(componentList, customData,lhsContents);
  navigateToSections(true,lhsContents,name);
  LoadJsonData();*/
  setWindowLocationHash('#'+name);
  putDataInDevCenterDataStore({type: 'UPDATE_HOME_SECTION_LINK_FLAG', homeSectionLinkFlag: true})
}

let partnerName, cybsProductMapJson, partnerProductMapJson;
const initializeJson = function(){
  partnerName = getPartnerName();
  if (partnerName !== "cybs") {
    cybsProductMapJson = getCybsProductMapJson();
    partnerProductMapJson = getPartnerProductMapJson();
  }
}

const whiteLabelText = (text) => {
  if (partnerName !== "cybs") {
    if (cybsProductMapJson && partnerProductMapJson) {
      var productShortName = Object.keys(cybsProductMapJson).find(key => text.includes(cybsProductMapJson[key]));
      if (productShortName && partnerProductMapJson.hasOwnProperty(productShortName)){
        text = text.replaceAll(cybsProductMapJson[productShortName],partnerProductMapJson[productShortName]);
      }
    }
  }  
  return text;
}

const getProductId = (lhsContents, productName) =>{
  if(partnerName !== "cybs") {
    for(let i=0; i<lhsContents.length; i++){
      let items = lhsContents[i]?.items;
      if(items?.length > 0){
        for(let j=0; j<items.length; j++){
          const title = items[j]?.title?.props?.children[0] || items[j]?.title;
          const whiteLabelTitleText = whiteLabelText(title);
          if(whiteLabelTitleText === productName) {
            return items[j]?.id;
          }
        }
      }
    }
  }
};


const isProduct = (text) => {
  if (partnerName !== "cybs") {
    if (cybsProductMapJson && partnerProductMapJson && Object.entries(cybsProductMapJson).length != 0 && Object.entries(partnerProductMapJson).length != 0) {
      var cybsProductShortName = Object.keys(cybsProductMapJson).find(key => text.includes(cybsProductMapJson[key]));
      if (cybsProductShortName && partnerProductMapJson.hasOwnProperty(cybsProductShortName)) {
        return true;
      }
    } else if (!cybsProductMapJson || !partnerProductMapJson || Object.entries(cybsProductMapJson).length == 0 || Object.entries(partnerProductMapJson).length == 0) {
      return true;
    }
  } else if (partnerName === "cybs") {
    return true;
  }
  return false;
}

const StaticHomeSection = (props) => {
  const [isCollapsed, onCollapse] = useState(false);
  var partnerFullName= getPartnerFullName();
  var useFontStyleFromEPCFlag = useFontStyleFromEPC();
  var miniTilesJson = getMappingJsonFromID("mini-tiles-map");
  const customData = require('../../../dist/json/lhs/'+getLHSBasedOnHostName());
  var lhsContents = getLHSJsonData([], customData,{}, false);

  initializeJson();
  if(!sessionStorage.getItem('jwttoken')){
    setDefaultHTTPCredsInCookies();
    setDefaultJWTCredsInCookies();
  }

  var titleString="REST API Reference";

return (
      <div style = {{background: "#c3c0c012"}}>
      <CybsHeader
            breadCrumbs={[
              {
                pageTitle: 'Home'
              }
            ]}
            i18n={{
              ariaLabel: 'Navigation List',
              title: titleString
            }}
            dataTest="header-basic"
          />
      {getPartnerName() === "cybs" &&
      <div style = {{display: "flex"}}>      
        {isProduct("Payments") && <div class = "content-mini-card-container color_theme_primary">
          <Card type = "content--mini" className = "border_color_theme_primary_bottom_shadow">
            <CardContent>
              <Typography tag="h3" variant="title--alt" className={`${useFontStyleFromEPCFlag ? "fontStyle" : ""}`}>
                {whiteLabelText("Payments")}
              </Typography>
              <Typography variant="body">
                {whiteLabelText("Accept payments using a variety of payment types")}
              </Typography>
              <Link class="color_theme_link" tabindex={0} aria-label={`${whiteLabelText('View Payments API')}`} inline onClick={() => onClicker('payments')}>{whiteLabelText('View Payments API ') + '\u276F'}</Link>
            </CardContent>
          </Card>
        </div>}
        {isProduct("Flex Microform") && <div class = "content-mini-card-container color_theme_primary">
          <Card type = "content--mini" className = "border_color_theme_primary_bottom_shadow">
            <CardContent>
              <Typography tag="h3" variant="title--alt" className={`${useFontStyleFromEPCFlag ? "fontStyle" : ""}`}>
                {whiteLabelText("Flex Microform")}
              </Typography>
              <Typography variant="body">
                {whiteLabelText("Securely tokenize card data by encrypting it on the customer’s device")}
              </Typography>
              <Link class="color_theme_link" tabindex={0} aria-label={`${whiteLabelText('View Flex Microform API')}`} inline  onClick={() => onClicker('flex-microform')}>{whiteLabelText('View Flex Microform API ') + '\u276F'}</Link>
            </CardContent>
          </Card>
        </div>} 
        {isProduct("Token Management") && <div class = "content-mini-card-container color_theme_primary">
          <Card type = "content--mini" className = "border_color_theme_primary_bottom_shadow">
            <CardContent>
              <Typography tag="h3" variant="title--alt" className={`${useFontStyleFromEPCFlag ? "fontStyle" : ""}`}>
                {whiteLabelText("Token Management")}
              </Typography>
              <Typography variant="body">
                {whiteLabelText("Replaces sensitive payment data in your environment with a unique identifier")}
              </Typography>
              <Link class="color_theme_link" tabindex={0} aria-label={`${whiteLabelText('View TMS API')}`} inline onClick={() => onClicker('token-management')}>{whiteLabelText('View TMS API ') + '\u276F'}</Link>
            </CardContent>
          </Card>
        </div>}
      </div>}

      {getPartnerName() !== "cybs" &&
      <div style = {{display: "flex"}}>
        {Object.keys(miniTilesJson).map((key)=> (
          <div class = "content-mini-card-container color_theme_primary">
          <Card type = "content--mini" className = "border_color_theme_primary_bottom_shadow">
            <CardContent>
              <Typography tag="h3" variant="title--alt" className={`${useFontStyleFromEPCFlag ? "fontStyle" : ""}`}>
                {key}
              </Typography>
              <Typography variant="body">
                {miniTilesJson[key]}
              </Typography>
              <Link class="color_theme_link" tabindex={0} aria-label={`${whiteLabelText('View '+ key)}`} inline onClick={() => onClicker(getProductId(lhsContents,key))}>{whiteLabelText('View '+ key) + '\u276F'}</Link>
            </CardContent>
          </Card>
        </div>
       ))}
      </div>}

      <div id = "Hello-World-Card" style={{ marginBottom: '50px', width: "90%", margin: "1%"}}>
        <Card type="content" style={{width: '64.5%', display: 'flex'}}>
          <CardContentImage
            style={{
              backgroundImage: 'url('+require('../../../images/CYBS-image.png')+')',
              maxWidth: '50%'
            }}
          />
          <CardContent>
            <Typography tag="h3" variant="title--alt">
              Hello World
            </Typography>
            <CardContentSeparator />
            <Typography variant="body">
              Learn how to do your first transaction with this simple tutorial.
            </Typography>
            <CardContentFooter>
              <Link class="color_theme_link" tabindex={0} rel="noopener" href="/hello-world.html" target="_blank" inline>
                <span className = "tutorial-button vds-btn-text--secondary border_color_theme_primary vds-btn-label">Get Started</span>
              </Link>
            </CardContentFooter>
          </CardContent>
        </Card>
      </div>
      <div id = "YouTube-Card" style={{margin:'1%',width:"90%"}}>
            <div>
              <CybsCard
                dataTest="info-pane-with-video"
                header={
                  <CybsActionBar
                    i18n={{title: 'First time user? Get started here'}}
                    dataTest="infor-pane-with-video"
                  />
                }
                style={{width: '64.5%'}}
              >
                <div style={{padding: '2%'}}>
                <p> 
                    Welcome to the {partnerFullName} REST API Reference Guide. This guide contains field-level descriptions grouped by
                    requests and responses, API request/response examples, and code samples in a variety of popular languages.
                </p>
                <p>
                    If you are new to {partnerFullName}, and would like to start writing code and testing requests and responses quickly, begin by
                    <a class="color_theme_link" href={getSignUpURL()} target="_blank" rel="noopener noreferrer"> signing up for a Sandbox Account</a>. You will receive an API login and API key that you can use to authenticate requests to our sandbox server. You can
                    even send requests and receive responses directly in this reference guide! Just plug in your API login and API key
                    into any of the request examples on this page and click Send.
                </p>
                <p>
                    In addition to this reference guide, you can also read our <a class="color_theme_link" href="/api/developer-guides.html"  target="_blank" rel="noopener noreferrer">API Developer Guides</a> for more complete
                    explanations of how each component in the REST API works, and how they work together.
                </p>
                <p>
                Note: All APIs listed here are not available for all gateway providers. Please contact your gateway provider for availability.
                </p>
                </div>
              </CybsCard>
            </div>                                                                                                                                
        </div>
                                        
        </div>
  );
};


StaticHomeSection.displayName = 'StaticHomeSection';
export default StaticHomeSection;
